export default "__VITE_ASSET__Dhej79fZ__"